module.exports = __webpack_public_path__ + "static/media/transferFrequentDestination.77d18361.svg";